const API_BASE = 'https://www.wopig.cz/api';

class ApiService {
  constructor() {
    this.authErrorHandler = null;
  }

  setAuthErrorHandler(handler) {
    this.authErrorHandler = handler;
  }

  getAuthHeaders() {
    const token = localStorage.getItem('auth_token');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  }

  async handleResponse(response) {
    if (!response.ok) {
      // Check for authentication errors
      if (response.status === 401 || response.status === 403) {
        if (this.authErrorHandler) {
          this.authErrorHandler();
        }
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  async fetchUnits() {
    const response = await fetch(`${API_BASE}/unit`, {
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse(response);
  }

  async fetchTimestampedData(unit, id = null, deserialize = false) {
    let url = `${API_BASE}/timestamped?unit=${encodeURIComponent(unit)}`;
    if (id !== null && id !== '') {
      url += `&id=${encodeURIComponent(id)}`;
    }
    if (deserialize) {
      url += '&deserialize=true';
    }

    const response = await fetch(url, {
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse(response);
  }

  async fetchPlainData(unit, id = null, deserialize = false) {
    let url = `${API_BASE}/plain?unit=${encodeURIComponent(unit)}`;
    if (id !== null && id !== '') {
      url += `&id=${encodeURIComponent(id)}`;
    }
    if (deserialize) {
      url += '&deserialize=true';
    }

    const response = await fetch(url, {
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse(response);
  }

  async ping() {
    const response = await fetch(`${API_BASE}/ping`, {
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse(response);
  }

  async fetchSpace() {
    const response = await fetch(`${API_BASE}/space`, {
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse(response);
  }
}

export default new ApiService();

